import React from "react";
import ProductSpread from "../ProductSpread/ProductSpread";
import prints from "../Assets/all_prints";

const AllPrints = () => {
  return (
    <div>
      <ProductSpread products={ prints } />
    </div>
  );
};

export default AllPrints;
